import React, { useEffect, useState } from 'react'
import { useStyles } from './FooterLinks_style'
import { Box, Typography, Container, Chip, Hidden } from '@material-ui/core'
import Button from 'components/Button/Button'
import CollectionHandler from 'assets/CollectionHandler'
import NavigationAPI from 'api/NavigationAPI'
import RouteMapLink from 'wrappers/RouteMapLink/RouteMapLink'
import RouteMap from 'assets/RouteMap'
import { FormattedMessage } from 'react-intl'
import isEmpty from 'lodash.isempty'
import IconFactory from 'shared/icons/IconFactory/IconFactory'

const Section = (props) => {
    const { children, title, page } = props
    const classes = useStyles()
    const [openAccordian, setOpenAccordian] = useState(false)

    return (
        <Box className={classes.section}>
            <Hidden xsDown>
                <Typography className={classes.sectionTitle}>
                    {title}
                </Typography>
                <Box className={classes.items}>
                    {children}
                </Box>
            </Hidden>
            <Hidden smUp>
                <Box className={classes.titleBox} onClick={() => setOpenAccordian(!openAccordian)}>
                    <Typography className={classes.sectionTitle}>
                        {title}
                    </Typography>
                    {!openAccordian && <IconFactory icon='down'/>}
                    {openAccordian && <IconFactory icon='up'/>}
                </Box>
                <Box className={classes.items}>
                    {children.slice(0, 4)}
                    {openAccordian && children.slice(4)}
                </Box>
            </Hidden>
            <RouteMapLink page={page}>
                <Button variant='secondary' size='small'>
                    <FormattedMessage id={`page_footer_links.see_all.${page}`}/>
                </Button>
            </RouteMapLink>
        </Box>
    )
}

const FooterLinks = (props) => {
    const { page } = props
    const classes = useStyles()
    const completeStudyDomainList = CollectionHandler.Get('studyDomainCollection')
        .map((studyD) => { return studyD.value })
    const [studyDomains, setStudyDomains] = useState([])
    const [cities, setCities] = useState([])
    const [provinces, setProvinces] = useState([])

    useEffect(() => {
        NavigationAPI.GetNavigationBestCollection({
            locale: RouteMap.GetLocaleFromUrl(),
            type: page
        }).then((response) => {
            response.data.study_domains && setStudyDomains(response.data.study_domains)
            response.data.cities && setCities(response.data.cities)
            response.data.provinces && setProvinces(response.data.provinces)
            if (page === 'education') setStudyDomains(completeStudyDomainList)
        })
    }, [])

    if (isEmpty(studyDomains) && isEmpty(cities) && isEmpty(provinces)) return null

    return (
        <Container maxwidth='lg' disableGutters>
            <Box className={classes.container}>
                {!isEmpty(studyDomains) &&
                    <Section title={<FormattedMessage id={`page_footer_links.${page}.domains_title`} />} page={page}>
                        {studyDomains.map((item) => {
                            return (
                                <RouteMapLink key={item.index} itemType={page} domain={item}>
                                    <Chip
                                        label={CollectionHandler.Translate('studyDomainCollection', item)}
                                        onClick
                                        href='student.be'
                                    />
                                </RouteMapLink>
                            )
                        })}
                    </Section>
                }
                {!isEmpty(cities) &&
                    <Section title={<FormattedMessage id={`page_footer_links.${page}.cities_title`}/>} page={page}>
                        {cities.map((item) => {
                            return (
                                <RouteMapLink key={item.index} itemType={page} location={item.value_name}>
                                    <Chip
                                        label={item.name}
                                        onClick
                                        href='student.be'
                                    />
                                </RouteMapLink>
                            )
                        })}
                    </Section>
                }
                {!isEmpty(provinces) &&
                    <Section title={<FormattedMessage id={`page_footer_links.${page}.provinces_title`}/>} page={page}>
                        {provinces.map((item) => {
                            const provinceUrl = `${RouteMap.Index(page)}?province=${item}`

                            return (
                                <RouteMapLink key={item.index} redirectionUrl={provinceUrl}>
                                    <Chip
                                        label={CollectionHandler.Translate('schoolProvinceCollection', item)}
                                        onClick
                                        href='student.be'
                                    />
                                </RouteMapLink>

                            )
                        })}
                    </Section>
                }
            </Box>
        </Container>
    )
}

export default FooterLinks
